import { Plugin, PluginKey } from '@tiptap/pm/state';

/**
 * A link mark that renders a real <a href> looks like a link and keeps its
 * destination for a future "open link" affordance. But inside the editor
 * that href is a trap: clicking it navigates away from the page (the
 * browser's loading bar, then the linked page) instead of placing the caret
 * to edit. Swallow the anchor's default navigation so a click just moves
 * the cursor into the link, like any other editable text.
 */
export function swallowAnchorClicks(name: string, selector: string): Plugin {
   return new Plugin({
      key: new PluginKey(name),
      props: {
         handleDOMEvents: {
            click: (_view, event) => {
               const target = event.target;
               if (target instanceof Element && target.closest(selector)) {
                  event.preventDefault();
                  // The global page loader (Shared/utils/loader.ts) has a
                  // document-level click handler that starts its progress
                  // bar for internal anchor clicks and doesn't check
                  // defaultPrevented. Without stopping propagation, an
                  // in-editor link click leaves a loading bar with no
                  // navigation to ever clear it.
                  event.stopPropagation();
               }
               return false;
            },
         },
      },
   });
}
